(function () {
  angular.module("akitabox.ui.dialogs.print", [
    "ngMaterial",
    "akitabox.core.services.http",
    "akitabox.core.services.file",
    "akitabox.core.services.flag",
  ]);
})();
